import {Component, OnInit} from "@angular/core";
import {AnnouncementService} from "../../../../../shared/services/announcement.service";
import {PaginationObject} from "../../../pagination-object";

@Component({
    selector: 'announcementpagination',
    templateUrl: './pagination.component.html'
})
export class AnnouncementPaginationComponent implements OnInit {

    constructor(private announcementService: AnnouncementService) {
    }

    pagination: PaginationObject = new PaginationObject();
    status: string;

    ngOnInit(): void {
        this.announcementService.currentAnnouncementPagination.subscribe(message => this.pagination = message);
        this.announcementService.currentAnnouncementStatus.subscribe(message => this.status = message);
    }

    selectPage(page: any) {
        this.pagination.pageSize = page.pageSize;
        this.pagination.currentPage = page.pageIndex;
        this.getAnnouncements();
    }

    selectStatus() {
        this.pagination.currentPage = 0;
        this.getAnnouncements();
    }

    getAnnouncements() {
        this.announcementService.updatePagination(this.pagination.totalCount);
        this.announcementService.updateStatus(this.status);
        this.announcementService.getAnnouncementsPaginated().subscribe(resp => {
            this.announcementService.changeMessage(this.announcementService.toRecordObjectList(resp));
        }, error => {
        }, () => {
            this.announcementService.getAnnouncementCount().subscribe(resp => {
                this.announcementService.updatePagination(resp)
            });
        });
        document.querySelector('#announcementScrollPane').scrollTop = 0;
    }
}
